import type { NamePool } from "@/core/types.js";

export const usNamePool: NamePool = {
  given: {
    male: [
      "James", "John", "Robert", "Michael", "William", "David", "Richard",
      "Joseph", "Thomas", "Charles", "Christopher", "Daniel", "Matthew",
      "Anthony", "Donald", "Mark", "Paul", "Steven", "Andrew", "Kenneth",
      "Joshua", "Kevin", "Brian", "George", "Timothy", "Ronald", "Edward",
      "Jason", "Jeffrey", "Ryan", "Jacob", "Gary", "Nicholas", "Eric",
    ],
    female: [
      "Mary", "Patricia", "Jennifer", "Linda", "Barbara", "Elizabeth",
      "Susan", "Jessica", "Sarah", "Karen", "Lisa", "Nancy", "Betty",
      "Margaret", "Sandra", "Ashley", "Dorothy", "Kimberly", "Emily",
      "Donna", "Michelle", "Carol", "Amanda", "Melissa", "Deborah",
      "Stephanie", "Rebecca", "Sharon", "Laura", "Cynthia", "Kathleen",
      "Amy", "Angela", "Shirley", "Anna",
    ],
  },
  family: [
    "Smith", "Johnson", "Williams", "Brown", "Jones", "Garcia", "Miller",
    "Davis", "Rodriguez", "Martinez", "Hernandez", "Lopez", "Gonzalez",
    "Wilson", "Anderson", "Thomas", "Taylor", "Moore", "Jackson", "Martin",
    "Lee", "Perez", "Thompson", "White", "Harris", "Sanchez", "Clark",
    "Ramirez", "Lewis", "Robinson", "Walker", "Young", "Allen", "King",
    "Wright", "Scott", "Torres", "Nguyen", "Hill", "Flores", "Green",
    "Adams", "Nelson", "Baker", "Hall", "Rivera", "Campbell", "Mitchell",
  ],
};
